import { LoadingSkeleton } from '@/components/LoadingSkeleton/LoadingSkeleton'

type CitatorCasesLoadingSkeletonProps = {
  rows?: number
}

export function CitatorCasesLoadingSkeleton({ rows = 2 }: CitatorCasesLoadingSkeletonProps) {
  return (
    <div className="flex flex-col gap-5 px-3">
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className="flex flex-col gap-2">
          <LoadingSkeleton width={105} lineHeight={16} />
          <LoadingSkeleton width={167} lineHeight={16} />
          <LoadingSkeleton width={134} lineHeight={16} />
          <LoadingSkeleton width="100%" lineHeight={16} />
          <LoadingSkeleton width="100%" lineHeight={16} />
          <LoadingSkeleton width="100%" lineHeight={16} />
        </div>
      ))}
    </div>
  )
}
